import type { ShiftFormActor } from "../../../shared/shift-production-form/contracts";

export function approvalAccessState(
  sessionPhase: "loading" | "ready" | "error",
  actor: ShiftFormActor | null,
) {
  if (sessionPhase === "loading") return "LOADING" as const;
  if (sessionPhase === "error") return "SERVICE_UNAVAILABLE" as const;
  if (actor?.kind === "OPERATOR") return "CLEAR_OPERATOR" as const;
  if (actor?.kind === "CORPORATE" || actor?.kind === "APPROVER") return "WORKSPACE" as const;
  return "AUTH" as const;
}
